// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2-ySo","info":"PatientInfo_info__36bs8"};